"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.typeBundleForPolkadot = exports.types26 = exports.types25 = exports.types23 = exports.types21 = exports.types20 = exports.types19 = exports.types18 = exports.types17 = exports.types12 = exports.types10 = exports.types9 = exports.types8 = void 0;
const types_8_1 = require("./types_8");
Object.defineProperty(exports, "types8", { enumerable: true, get: function () { return types_8_1.types8; } });
const types_9_1 = require("./types_9");
Object.defineProperty(exports, "types9", { enumerable: true, get: function () { return types_9_1.types9; } });
const types_10_1 = require("./types_10");
Object.defineProperty(exports, "types10", { enumerable: true, get: function () { return types_10_1.types10; } });
const types_12_1 = require("./types_12");
Object.defineProperty(exports, "types12", { enumerable: true, get: function () { return types_12_1.types12; } });
const types_17_1 = require("./types_17");
Object.defineProperty(exports, "types17", { enumerable: true, get: function () { return types_17_1.types17; } });
const types_18_1 = require("./types_18");
Object.defineProperty(exports, "types18", { enumerable: true, get: function () { return types_18_1.types18; } });
const types_19_1 = require("./types_19");
Object.defineProperty(exports, "types19", { enumerable: true, get: function () { return types_19_1.types19; } });
const types_20_1 = require("./types_20");
Object.defineProperty(exports, "types20", { enumerable: true, get: function () { return types_20_1.types20; } });
const types_21_1 = require("./types_21");
Object.defineProperty(exports, "types21", { enumerable: true, get: function () { return types_21_1.types21; } });
const types_23_1 = require("./types_23");
Object.defineProperty(exports, "types23", { enumerable: true, get: function () { return types_23_1.types23; } });
const types_25_1 = require("./types_25");
Object.defineProperty(exports, "types25", { enumerable: true, get: function () { return types_25_1.types25; } });
const types_26_1 = require("./types_26");
Object.defineProperty(exports, "types26", { enumerable: true, get: function () { return types_26_1.types26; } });
exports.typeBundleForPolkadot = {
    types: [
        {
            minmax: [0, 8],
            types: types_8_1.types8,
        },
        {
            minmax: [9, 9],
            types: types_9_1.types9,
        },
        {
            minmax: [10, 11],
            types: types_10_1.types10,
        },
        {
            minmax: [12, 16],
            types: types_12_1.types12,
        },
        {
            minmax: [17, 17],
            types: types_17_1.types17,
        },
        {
            minmax: [18, 18],
            types: types_18_1.types18,
        },
        {
            minmax: [19, 19],
            types: types_19_1.types19,
        },
        {
            minmax: [20, 20],
            types: types_20_1.types20,
        },
        {
            minmax: [21, 22],
            types: types_21_1.types21,
        },
        {
            minmax: [23, 24],
            types: types_23_1.types23,
        },
        {
            minmax: [25, 25],
            types: types_25_1.types25,
        },
        {
            minmax: [26, undefined],
            types: types_26_1.types26,
        },
    ],
};
